import { FormGroup } from "@angular/forms";

export const FF_DEFAULT_CLASS_LIST = ["min-width-400", "col-xs-12"];

export abstract class FormFactoryBase {
  patchForm(form: FormGroup, obj: any) {
    form.patchValue(obj);
  }
}
